import React from 'react';

const SectionLoader: React.FC = () => {
  return (
    <div className="w-full py-20 flex items-center justify-center bg-slate-50" aria-hidden="true">
      <div className="w-10 h-10 border-2 border-emerald-200 border-t-emerald-600 rounded-full animate-spin"></div>
    </div>
  );
};

export default SectionLoader;
